<template>
  <div class="premium-message-send-complete">
    <img src="/images/premium_message/send-complete.png" alt="send-complete" class="send-complete-image" />
    <div class="complete-text">
      プレミアムメッセージを<br />
      送りました
    </div>
    <div class="users">
      <img :src="fromUserImageUrl" class="user-icon from-user" />
      <div class="arrows">
        <i class="bi bi-chevron-right"></i>
        <i class="bi bi-chevron-right"></i>
        <i class="bi bi-chevron-right"></i>
        <i class="bi bi-chevron-right"></i>
        <i class="bi bi-chevron-right"></i>
      </div>
      <img :src="toUserImageUrl" class="user-icon to-user" />
    </div>
    <button type="button" class="close" @click="close">
      とじる
    </button>
  </div>
</template>

<script>
export default {
  emits: ['close'],
  props: {
    fromUserImageUrl: {
      type: String,
      default: '',
    },
    toUserImageUrl: {
      type: String,
      default: '',
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
  }
}
</script>

<style scoped>
.premium-message-send-complete {
  position: fixed;
  top: 0;
  left: 50%;
  max-width: 540px;
  width: 100%;
  min-height: 100%;
  transform: translateX(-50%);
  padding-top: 48px;
  background-color: #4f3f81;
  text-align: center;
}

.complete-text {
  margin-top: 8px;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
}

.users {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
}

.user-icon {
  width: 92px;
  height: 92px;
  border-radius: 8px;
}

.arrows {
  padding: 16px;
  color: #fff;
  font-size: 15px;
}

.arrows .bi-chevron-right {
  margin: 0 -4px;
  -webkit-text-stroke: 1px;
}

.arrows .bi-chevron-right:before {
  transform: scaleY(1.2);
}

.close {
  width: calc(100% - 64px);
  margin: 32px;
  padding: 16px 12px;
  color: #fff;
  background-color: transparent;
  border: 1px solid #fff;
  border-radius: 64px;
}
</style>
